import { useState, useEffect } from "react";

export function useDomain(): string | undefined {
  const getDomain = (): string | undefined => {
    const url = window.location.href;
    const subdomainRegExp = /(?:http[s]*:\/\/)*(.*?)\.(?=[^/]*\..{2,5})/i;
    const subdomain = url.match(subdomainRegExp)?.[1];

    return subdomain;
  };

  const [domain, setDomain] = useState<string | undefined>(getDomain());

  useEffect(() => {
    if (window.location.href) {
      setDomain(getDomain());
    }
  }, []);

  return domain;
}
